import { Injectable, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import { dvNumberMaskPresets } from '@devinco/ui/dds';
import {
  DvCheckboxElement,
  DvDropdownClientSideElement,
  DvNumberboxElement,
  DvTextareaElement,
  DvDynamicFormElement,
} from '@devinco/ui/legacy';
import { Entity } from '@shared/constants/entity';

@Injectable()
export class ExpenseEditDialogFormService {
  private api = inject(RestApiService);

  readonly lowerFormElements = [
    new DvNumberboxElement({
      key: 'Rate',
      label: 'Trip.Expense.EditModal.Rate',
      fieldMask: dvNumberMaskPresets.FormattedDecimalNumber,
    }),
    new DvNumberboxElement({
      key: 'Amount',
      disabled: true,
      label: 'Trip.Expense.EditModal.Sum',
      fieldMask: dvNumberMaskPresets.FormattedDecimalNumber,
    }),

    new DvTextareaElement({
      key: 'Comment',
      label: 'Trip.Expense.EditModal.Comment',
      rowspan: 2,
    }),
    new DvCheckboxElement({
      key: 'IsPrivateTaxable',
      checkboxLabel: 'Trip.Expense.EditModal.IsPrivateTaxable',
    }),
  ];

  readonly upperFormElements = (entityId: number): DvDynamicFormElement[] => {
    return [
      new DvDropdownClientSideElement({
        isClearable: true,
        key: 'ExpenseSettingID',
        label: 'Trip.Expense.EditModal.ExpenseType',
        labelKeys: ['ExpenseType'],
        valueKey: 'ExpenseSettingID',
        validators: [Validators.required],
        open: params => {
          const request: GetRowsRequest = {
            entity: Entity.TripExpenseSetup,
            fields: [
              'ExpenseSettingID',
              'ExpenseType',
              'RateEnabled',
              'TripDistanceConnection',
              'Rate',
              'TranslationKey',
            ],
            filterModel: {
              TripID: {
                filterType: 'number',
                type: 'equals',
                filter: entityId,
              },
            },
          };
          this.api.setTranslatedDropdownData(request, params, 'TranslationKey');
        },
      }),
      new DvNumberboxElement({
        key: 'Quantity',
        label: 'Trip.Expense.EditModal.Quantity',
        fieldMask: dvNumberMaskPresets.FormattedDecimalNumber,
      }),
    ];
  };
}
